import React from "react";
import "./Order_Process_Cart.css";
import OrderSummary from "../../Common-Component/OrderSummary/OrderSummary";
import Edit_Design_Cards from "./Edit_Design_Cards/Edit_Design_Cards";

function Order_Process_Cart({ cart }) {
  return (
    <>
      <section className="Order_Process_Cart">
        <div className="row">
          <div className="col-lg-8 col-md-7">
            {cart?.data?.data?.map((val) => (
              <Edit_Design_Cards val={val}/>
            ))}
            {/* <Edit_Design_Cards /> */}
          </div>

          <div className="col-lg-4 col-md-6">
            <OrderSummary cart={cart} order={'order'}/>
          </div>
        </div>
      </section>
    </>
  );
}

export default Order_Process_Cart;
